import * as Styles from './styles'

type Props = {
  caption?: string
  header: string
  description?: string
}

export const Header = ({ caption, header, description }: Props) => {
  return (
    <Styles.Container data-testid="onboarding-header">
      {caption && <Styles.Caption data-testid="onboarding-caption">{caption}</Styles.Caption>}
      <Styles.InfoContainer data-testid="onboarding-header-info">
        <Styles.Header data-testid="onboarding-header-title">{header}</Styles.Header>
        {description && (
          <Styles.Description data-testid="onboarding-header-description">
            {description}
          </Styles.Description>
        )}
      </Styles.InfoContainer>
    </Styles.Container>
  )
}
